module.exports = __webpack_public_path__ + "img/kid_first-desktop.bf8a45bb.svg";